import React from 'react';
import { useMutation } from '@apollo/client';
import NProgress from 'nprogress';
import { Button } from '@avila-tek/ui/src/Button';
import { useNotify } from '../../hooks';
import { DocumentModel, Settings } from '../../models';
import { CREATE_SETTINGS, UPDATE_SETTINGS } from '../../graphql/mutation';
import { DocumentForm } from '../shared';

interface ManageBannerProps {
  settings: Settings;
}

function ManageBanner({ settings }: ManageBannerProps) {
  const notify = useNotify();
  const [disabled, setDisabled] = React.useState(false);

  const [createSettingsMutation] = useMutation<{
    createSettings: { record: Settings };
  }>(CREATE_SETTINGS);
  const [updateSettingsMutation] = useMutation<{
    updateSettings: { record: Settings };
  }>(UPDATE_SETTINGS);

  const createSettings = async (settingsData: Partial<Settings>) => {
    const { data } = await createSettingsMutation({
      variables: {
        record: {
          ...settingsData,
        },
      },
    });
    if (data?.createSettings.record?._id) {
      notify('Banner creado con éxito', 'success');
    } else {
      notify('Ha ocurrido un error al crear el banner', 'error');
    }
  };

  const [documents, setDocuments] = React.useState<
    Array<Partial<DocumentModel>>
  >(
    settings?.carouselImages?.length > 0
      ? [{ src: settings?.carouselImages[0]?.url ?? '' }]
      : []
  );
  const [documents1, setDocuments1] = React.useState<
    Array<Partial<DocumentModel>>
  >(
    settings?.carouselImages?.length > 0
      ? [{ src: settings?.carouselImages[1]?.url ?? '' }]
      : []
  );

  const [documents2, setDocuments2] = React.useState<
    Array<Partial<DocumentModel>>
  >(
    settings?.carouselImages?.length > 0
      ? [{ src: settings?.carouselImages[2]?.url ?? '' }]
      : []
  );
  const [documents3, setDocuments3] = React.useState<
    Array<Partial<DocumentModel>>
  >(
    settings?.carouselImages?.length > 0
      ? [{ src: settings?.carouselImages[3]?.url ?? '' }]
      : []
  );
  const [documents4, setDocuments4] = React.useState<
    Array<Partial<DocumentModel>>
  >(
    settings?.carouselImages?.length > 0
      ? [{ src: settings?.carouselImages[4]?.url ?? '' }]
      : []
  );

  const idx = settings.carouselImages.findIndex(
    (carousel) => carousel._id === settings?.carouselImages[0]?._id
  );
  const idx1 = settings.carouselImages.findIndex(
    (carousel) => carousel._id === settings?.carouselImages[1]?._id
  );
  const idx2 = settings.carouselImages.findIndex(
    (carousel) => carousel._id === settings?.carouselImages[2]?._id
  );
  const idx3 = settings.carouselImages.findIndex(
    (carousel) => carousel._id === settings?.carouselImages[3]?._id
  );
  const idx4 = settings.carouselImages.findIndex(
    (carousel) => carousel._id === settings?.carouselImages[4]?._id
  );

  const updateSettings = async (settingsData: Partial<Settings>) => {
    const { data } = await updateSettingsMutation({
      variables: {
        filter: {
          _id: settings._id,
        },
        record: {
          ...settingsData,
          _id: undefined,
          __typename: undefined,
        },
      },
    });
    if (data?.updateSettings.record?._id) {
      notify('Banner actualizado con éxito', 'success');
    } else {
      notify('Ha ocurrido un error al actualizar el banner', 'error');
    }
  };

  const onSubmit = async (index, document) => {
    try {
      NProgress.start();
      // disabled validation
      if (disabled) return;
      setDisabled(true);

      const data = {
        ...settings,
        carouselImages: [
          ...settings.carouselImages.slice(0, index).map(function (elem) {
            const returnObjeto = {
              _id: elem._id,
              description: elem.description,
              link: elem.link,
              linkType: elem.linkType,
              title: elem.title,
              url: elem.url,
            };
            return returnObjeto;
          }),
          {
            url: document[0].src as string,
            title: 'Banner1',
          },
          ...(settings.carouselImages.slice(index + 1).map(function (elem) {
            const returnObjeto = {
              _id: elem._id,
              description: elem.description,
              link: elem.link,
              linkType: elem.linkType,
              title: elem.title,
              url: elem.url,
            };
            return returnObjeto;
          }) ?? []),
        ],
      };
      // create or update
      if (settings?._id) {
        await updateSettings(data);
      } else {
        await createSettings(data);
      }
    } catch (error) {
      notify(error.message, 'error');
    } finally {
      NProgress.done();
      setDisabled(false);
    }
  };

  return (
    <>
      <div className="flex w-full flex-col mb-6">
        <DocumentForm
          documents={documents}
          updateURLs={setDocuments}
          maximumAmount={1}
          title="Banner home 1"
        />
        <div className="flex justify-end mt-3">
          <div>
            <Button
              onClick={() => {
                onSubmit(idx, documents);
              }}
              disabled={disabled}
            >
              Actualizar
            </Button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col mb-6">
        <DocumentForm
          documents={documents1}
          updateURLs={setDocuments1}
          maximumAmount={1}
          title="Banner home 2"
        />
        <div className="flex justify-end mt-3">
          <div>
            <Button
              onClick={() => {
                onSubmit(idx1, documents1);
              }}
              disabled={disabled}
            >
              Actualizar
            </Button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col mb-6">
        <DocumentForm
          documents={documents2}
          updateURLs={setDocuments2}
          maximumAmount={1}
          title="Banner home 3"
        />
        <div className="flex justify-end mt-3">
          <div>
            <Button
              onClick={() => {
                onSubmit(idx2, documents2);
              }}
              disabled={disabled}
            >
              Actualizar
            </Button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col mb-6">
        <DocumentForm
          documents={documents3}
          updateURLs={setDocuments3}
          maximumAmount={1}
          title="Banner home 4"
        />
        <div className="flex justify-end mt-3">
          <div>
            <Button
              onClick={() => {
                onSubmit(idx3, documents3);
              }}
              disabled={disabled}
            >
              Actualizar
            </Button>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col mb-6">
        <DocumentForm
          documents={documents4}
          updateURLs={setDocuments4}
          maximumAmount={1}
          title="Banner del catálogo"
        />
        <div className="flex justify-end mt-3">
          <div>
            <Button
              onClick={() => {
                onSubmit(idx4, documents4);
              }}
              disabled={disabled}
            >
              Actualizar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageBanner;
